import { a as _defineProperty } from './_rollupPluginBabelHelpers-cf650413.js';
import IMask from 'imask/esm/imask';
import { isVue3 } from 'vue-demi';

var _name;
var directive = (_name = {
  name: 'imask'
}, _defineProperty(_name, isVue3 ? 'beforeMount' : 'bind', function (el, _ref) {
  var options = _ref.value;
  if (!options) return;
  initMask(el, options);
}), _defineProperty(_name, isVue3 ? 'updated' : 'update', function (el, _ref2) {
  var options = _ref2.value;

  if (options) {
    if (el.maskRef) {
      el.maskRef.updateOptions(options);
      if (el.value !== el.maskRef.value) el.maskRef._onChange();
    } else initMask(el, options);
  } else {
    destroyMask(el);
  }
}), _defineProperty(_name, isVue3 ? 'unmounted' : 'unbind', function (el) {
  destroyMask(el);
}), _name);

function fireEvent(el, eventName, data) {
  var e = document.createEvent('CustomEvent');
  e.initCustomEvent(eventName, true, true, data);
  el.dispatchEvent(e);
}

function initMask(el, opts) {
  el.maskRef = IMask(el, opts).on('accept', function () {
    return fireEvent(el, 'accept', el.maskRef);
  }).on('complete', function () {
    return fireEvent(el, 'complete', el.maskRef);
  });
}

function destroyMask(el) {
  if (el.maskRef) {
    el.maskRef.destroy();
    delete el.maskRef;
  }
}

export { directive as default };
